import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { AuthenticationService } from '../_services/auth/authentication.service';

@Injectable()
export class CommonInterceptor implements HttpInterceptor {

  constructor(private customAuthService: AuthenticationService) { }

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    let currentUser = this.customAuthService.currentUserValue;
    let skipContentTypeForURLs = [/screenshot/gi, /avatar/gi]; // Skip content-type when uploading file.
    let skipContentType = false;
    skipContentTypeForURLs.forEach(url => {
      if (request.url.search(url) === -1) {
        skipContentType = true;
        return;
      }
    });

    if (currentUser && currentUser.at) {
      if (skipContentType) {
        request = request.clone({
          setHeaders: {
            Authorization: `Bearer ${currentUser.at}`,
          }
        });
      } else {
        request = request.clone({
          setHeaders: {
            Authorization: `Bearer ${currentUser.at}`,
            'Content-Type': 'application/json'
          }
        });
      }
    } else {
      if (skipContentType) {
        request = request.clone({
          setHeaders: { }
        });
      }else{
        request = request.clone({
          setHeaders: {
            'Content-Type': 'application/json'
          }
        });
      }

    }
    return next.handle(request);
  }
}
